import ArrowBack from '@mui/icons-material/ArrowBack';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import AutoFixHigh from '@mui/icons-material/AutoFixHigh';
import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Edit from '@mui/icons-material/Edit';
import NotesOutlined from '@mui/icons-material/NotesOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  Switch,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  capitalize,
  useMediaQuery,
} from '@mui/material';
import moment from "moment";
import "moment/locale/fr";
import { useState, useEffect } from "react";
import { BiPhone } from "react-icons/bi";
import { FaUsers } from "react-icons/fa";
import {
  ReflexContainer,
  ReflexElement,
  ReflexSplitter
} from 'react-reflex';
import 'react-reflex/styles.css';
import { useHistory, useParams } from 'react-router-dom';
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import DialogDeleteCustom from "../../../components/DialogDeleteCustom/DialogDeleteCustom";
import EmailModal from "../../../components/EmailModal/EmailModal";
import Loader from "../../../components/Loader/Loader";
import TabPanelTaches from "../../../components/TabPanelTaches/TabPanelTaches";
import { TABLE } from "../../../enums/tablesEnum";
import { updateObjectStateValue, getSenioriteFromDate } from "../../../utils/FunctionHelpers";
import { withSnackbar } from "../../../utils/SnackbarHOC";
import { theme } from "../../../utils/Theme";
import "../../Contact/VisualiserContact/icons.css";
import Prospection from "../../Contact/VisualiserContact/Tabs/Prospection";
import { callCandidat, deleteCandidat, disableMailing, formatCvCandidat, getDetails } from "../../../services/CandidatService";
import { sendEmailCandidat } from "../../../services/ProcessService";
import {
  addCandidatsToSelection,
  deleteCandidatFromSelection,
  getSelectionDetails
} from "../../../services/SelectionCandidatService";
import { deleteTacheCandidat, getAll, getAllTachesFaites } from "../../../services/TacheCandidatService";
import SmsCandidat from "../EmailCondidat/SmsCandidat";
import Informations from "./Accordions/Informations";
import PostRecherche from "./Accordions/PostRecherche";
import SyntheseConsultant from "./Accordions/SyntheseConsultant";
import ShowCVCandidat from "./ShowCVCandidat";
import Collegues from "./Tabs/Collegues";
import Notes from "./Tabs/Notes";
import Process from "./Tabs/Process";
import Selections from "./Tabs/Selections";
import ProcessClient from "./Tabs/ProcessClient";
import "./visuialisation.css";
import "../../../styles/heroToolbar.css";
import ShowAddCvCandidat from "./ShowAddCvCandidat";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2.5, px: 2, pb: 2 }}>{children}</Box>}
    </div>
  );
}

const navBtnSx = {
  borderRadius: '8px',
  fontSize: '1rem',
  fontWeight: 600,
  px: 2,
  py: 0.6,
  textTransform: 'none',
};

function SectionCard({ title, children, noPadding = false, action = null }) {
  return (
    <Box sx={{ mb: 1.5, backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
      <Box sx={{ px: 2, py: 0.9, borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ width: 3, height: 14, borderRadius: 2, background: 'linear-gradient(180deg, #03407b, #02357a)', flexShrink: 0 }} />
        <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, color: '#6b7280', letterSpacing: '0.09em', textTransform: 'uppercase' }}>
          {title}
        </Typography>
        {action && <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>{action}</Box>}
      </Box>
      <Box sx={noPadding ? {} : { px: 2, pt: 1.5, pb: 1.5 }}>{children}</Box>
    </Box>
  );
}

function VisualiserCandidat({ selected, snackbarShowMessage }) {
  const history = useHistory();
  const location = useLocation();
  const getUserData = () => JSON.parse(localStorage.getItem("userData"));
  const userRole = getUserData()?.role[0];

  const [candidatDetails, setCandidatDetails] = useState({});
  const { idCandidat } = useParams();
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(history.location.state?.tabIndex || (userRole === "ROLE_TESTEUR" ? 1 : 0));
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [selectionData, setSelectionData] = useState({ isLoading: false, data: {} });
  const [societeId, setSocieteId] = useState(null);
  const { idSelection } = useParams();
  const props = { loadData, setLoadData, snackbarShowMessage, deleteTache: deleteTacheCandidat, getAll, getAllTachesFaites, tacheFrom: TABLE.CANDIDAT, societeId };
  const [loadingToDelete, setLoadingToDelete] = useState(false);
  const [loadingToCall, setLoadingToCall] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [cv, setCv] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [totalCondidat, setTotalCondidat] = useState(0);
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));
  const isMdMode = useMediaQuery(theme.breakpoints.between(481, 992));
  const candidatName = candidatDetails.prenom + " " + candidatDetails.nom;
  const [isTalentManager, setIsTalentManager] = useState(false);

  const getNavigationState = () => {
    if (history.location.state?.candidatsInList) {
      return { candidatsInList: history.location.state.candidatsInList, candidatIndex: history.location.state.candidatIndex };
    }
    const storedState = localStorage.getItem('viewCandidatState');
    if (storedState) {
      try {
        const parsed = JSON.parse(storedState);
        const list = parsed.candidatsInList || [];
        let idx = list.indexOf(parseInt(idCandidat));
        if (idx === -1) idx = list.indexOf(idCandidat);
        if (idx === -1) return { candidatsInList: [], candidatIndex: undefined };
        return { candidatsInList: list, candidatIndex: idx };
      } catch {}
    }
    return { candidatsInList: [], candidatIndex: undefined };
  };

  const navigationState = getNavigationState();
  const selectedCandidats = navigationState.candidatsInList;
  const [loadingToDisableMailing, setLoadingToDisableMailing] = useState(false);
  const [candidatIndex, setCandidatIndex] = useState(navigationState.candidatIndex);
  const [filterData, setFilterData] = useState({
    deletedCandidats: [],
    loading: false,
    isFiltering: history.location.state && history.location.state.filtering,
  });

  useEffect(() => {
    const role = getUserData()?.role || [];
    setIsTalentManager(role.includes('ROLE_TALENT_MANAGER'));
    if (userRole === "ROLE_TESTEUR") setValue(1);
  }, []);

  const handleCloseDialog = () => { if (!loadingToDelete) setOpenDialogDelete(false); };
  const [generatingCv, setGeneratingCv] = useState(false);

  const handleGenerateCvGoAndDev = async () => {
    setGeneratingCv(true);
    try {
      await formatCvCandidat(idCandidat);
      snackbarShowMessage("CV formaté avec succès", "success", 4000);
      setReloadData(c => !c);
    } catch (e) {
      snackbarShowMessage(e?.response?.data?.message || "Impossible de formater le CV.", "error", 4000);
    } finally { setGeneratingCv(false); }
  };

  const nextCandidat = () => setCandidatIndex(candidatIndex + 1);
  const previousCandidat = () => setCandidatIndex(candidatIndex - 1);
  const handleOpenDeleteDialog = () => setOpenDialogDelete(true);

  const editCandidat = (id, hist, num) => {
    hist.push({
      pathname: "/candidats/" + id + "/edit",
      state: { ...hist.location.state, candidatsInList: selectedCandidats, candidatIndex: selectedCandidats?.indexOf(selectedCandidats[candidatIndex]), selection: selectionData.data.id },
      search: `?num-candidat=${num}`
    });
  };

  const getSelection = () => {
    updateObjectStateValue(setSelectionData, { isLoading: true, data: {} });
    getSelectionDetails(idSelection)
      .then(({ data }) => updateObjectStateValue(setSelectionData, { isLoading: false, data }))
      .catch(() => snackbarShowMessage("Erreur de chargement des détails de la sélection.", "error", 4000))
      .finally(() => updateObjectStateValue(setSelectionData, { isLoading: false }));
  };

  const delay = ms => new Promise(r => setTimeout(r, ms));

  const deleteCandidatFromList = () => {
    (async () => {
      setLoadingToDelete(true);
      try {
        idSelection ? await deleteCandidatFromSelection(idCandidat, idSelection) : await deleteCandidat(idCandidat);
        snackbarShowMessage("Candidat supprimé avec succès", "success", 4000);
        await delay(1000);
        setLoadingToDelete(false);
        setOpenDialogDelete(false);
        history.replace({ pathname: '/' });
      } catch (err) {
        snackbarShowMessage(err.data || "An error occurred", "error", 4000);
        setLoadingToDelete(false);
      }
    })();
  };

  const handleSaveFilterToSelection = () => {
    updateObjectStateValue(setFilterData, { loading: true });
    addCandidatsToSelection(selectionData.data.uuid, { deletedCandidats: filterData.deletedCandidats, selectedCandidats })
      .then(({ data }) => {
        snackbarShowMessage(data);
        history.replace({ pathname: `/selections/${idSelection}/candidats/list`, search: `?selectionName=${selectionData.data.selectionName}&quantity=${selectedCandidats.length}&consultant=${candidatDetails.consultant.fullName}` });
      })
      .catch(({ response }) => snackbarShowMessage(response.data.error.detail, "error", 4000))
      .finally(() => updateObjectStateValue(setFilterData, { loading: false }));
  };

  useEffect(() => { if (idSelection) getSelection(); }, [idSelection]);
  useEffect(() => { if (!loadingToDelete && totalCondidat) setTotalCondidat(totalCondidat - 1); }, [loadingToDelete]);

  useEffect(() => {
    let active = true;
    (async () => {
      if (candidatDetails?.uuid !== idCandidat) {
        setLoading(true);
      }
      try {
        const candidat = await getDetails(idCandidat, idSelection ? `?selection=${idSelection}` : "");
        if (!active) return;
        setCv(candidat.data?.uploadedFiles || []);
        setCandidatDetails(candidat.data || {});
        setNom(candidat.data?.nom || '');
        setPrenom(candidat.data?.prenom || '');
        setEmail(candidat.data?.email || '');
        if (candidat.data?.employeur?.uuid) setSocieteId(candidat.data.employeur.uuid);
        setLoading(false);
      } catch {
        snackbarShowMessage("Erreur de chargement du candidat.", "error", 4000);
        setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [idCandidat, reloadData]);

  useEffect(() => {
    if (userRole === "ROLE_TESTEUR") { setValue(1); return; }
    const etat = new URLSearchParams(location.search).get('etat');
    const tab = new URLSearchParams(location.search).get('tab');
    if (etat === 'updated') snackbarShowMessage("Candidat mis à jour via l'extension", "warning", 4000);
    else if (etat === 'created') snackbarShowMessage("Candidat ajouté via l'extension", "success", 4000);
    const tabMap = { notes: 0, 'process client': 1, 'process intern': 2, taches: 3, selections: 4, approche: 5, collegues: 6 };
    setValue(tabMap[tab] ?? 0);
  }, [location.search]);

  useEffect(() => {
    if (selectedCandidats != undefined && candidatIndex !== undefined) {
      const candidat = selectedCandidats[candidatIndex];
      const state = { ...history.location.state, candidatsInList: selectedCandidats, candidatIndex: selectedCandidats.indexOf(candidat) };
      const pathname = idSelection === undefined ? `/candidats/${candidat}/view` : `/selections/${idSelection}/candidats/${candidat}/view`;
      history.replace({ pathname, state });
    }
    if (totalCondidat === null) setTotalCondidat(history.location.state?.numbersTotalOfSelections);
  }, [candidatIndex]);

  const handleTabs = (event, newValue) => {
    if (userRole === "ROLE_TESTEUR") { setValue(1); return; }
    setValue(newValue);
    const queryParams = new URLSearchParams(location.search);
    const tabKeys = ['notes', 'process client', 'process intern', 'taches', 'selections', 'approche', 'collegues'];
    if (tabKeys[newValue]) queryParams.set('tab', tabKeys[newValue]);
    history.replace({ pathname: location.pathname, search: queryParams.toString(), state: { ...history.location.state } });
  };

  const submitDisableMailing = () => {
    setLoadingToDisableMailing(true);
    snackbarShowMessage("Changement de statut emailing en cours ...", "info", 4000);
    disableMailing(candidatDetails.uuid)
      .then(() => snackbarShowMessage("Changement de statut emailing réussi !", "success", 4000))
      .catch(() => snackbarShowMessage("Une erreur s'est produite", "error", 4000))
      .finally(() => { setLoadingToDisableMailing(true); window.location.reload(); });
  };

  const submitCallCandidat = () => {
    setLoadingToCall(true);
    callCandidat({ candidat_number: candidatDetails.telephone })
      .then(() => snackbarShowMessage("Appel en cours...", 'warning'))
      .catch(() => snackbarShowMessage("Une erreur s'est produite (format invalide)", "error", 4000))
      .finally(() => setLoadingToCall(false));
  };

  const getUrlSelectedSelection = () => JSON.parse(window.localStorage.getItem('data_vivier_selected'));
  const [messageType, setMessageType] = useState();
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    email ? setOpenModal(true) : snackbarShowMessage("Aucun e-mail renseigné pour ce candidat.", "warning", 5000);
  };

  const tabs = [
    { name: "NOTES", icon: <NotesOutlined sx={{ fontSize: 17 }} /> },
    { name: "PROCESS INTERN", icon: <SettingsOutlined sx={{ fontSize: 17 }} /> },
    { name: "PROCESS CLIENT", icon: <SettingsOutlined sx={{ fontSize: 17 }} /> },
    { name: "TÂCHES", icon: <AssignmentOutlined sx={{ fontSize: 17 }} /> },
    { name: "SÉLECTIONS", icon: <CheckBoxOutlined sx={{ fontSize: 17 }} /> },
    { name: "APPROCHE", icon: <CheckCircleOutlined sx={{ fontSize: 17 }} /> },
    { name: "COLLÈGUES", icon: <FaUsers style={{ fontSize: 16 }} /> },
  ];

  const filteredTabs = userRole === "ROLE_TESTEUR"
    ? [{ name: "PROCESS INTERN", icon: <SettingsOutlined sx={{ fontSize: 17 }} /> }]
    : tabs;

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    open: openDialogDelete,
    handleConfirm: deleteCandidatFromList,
    loading: loadingToDelete,
    label: idSelection
      ? `Voulez vous vraiment supprimer le candidat ${candidatDetails.prenom} ${candidatDetails.nom} de cette sélection?`
      : `Voulez vous vraiment supprimer le candidat ${candidatDetails.prenom} ${candidatDetails.nom}?`,
  };

  const allTabPanels = [
    { index: 0, component: <Notes {...props} /> },
    {
      index: 1,
      component: candidatDetails ? (
        <ProcessClient
          {...props}
          candidatName={capitalize(prenom) + " " + nom}
          candidatEmail={candidatDetails.email}
          candidatTel={candidatDetails.telephone}
          candidatAccountManager={candidatDetails.accountManager}
          candidatConsultant={candidatDetails.consultant}
          candidatSeniorite={getSenioriteFromDate(candidatDetails.dateDebutExperience)}
          candidatCommentaire={candidatDetails.commentaire}
          candidatPointFort={candidatDetails.pointsforts}
          candidatSoftskills={candidatDetails.softskills}
          candidatFrancais={candidatDetails.francais}
          candidatAnglais={candidatDetails.anglais}
          candidatActuPackage={candidatDetails.actuellePackage}
          candidatActuFixe={candidatDetails.actuelleFixe}
          candidatActuVariable={candidatDetails.actuelleVariable}
          candidatActuInteress={candidatDetails.actuelleInteressement}
          candidatSouhaitePackage={candidatDetails.souhaitePackage}
          candidatsouhaiteFixe={candidatDetails.souhaiteFixe}
          candidatsouhaiteVariable={candidatDetails.souhaiteVariable}
          candidatsouhaiteInteress={candidatDetails.souhaiteInteress}
          candidatpreAvis={candidatDetails.preAvis}
          candidatdispoLe={candidatDetails.dispoLe}
          numCandidat={candidatDetails.numCandidat}
          processId={candidatDetails.processId}
          handleOpenModal={handleOpenModal}
          setMessageType={setMessageType}
        />
      ) : null,
    },
    {
      index: 2,
      component: candidatDetails ? (
        <Process
          {...props}
          candidatName={capitalize(prenom) + " " + nom}
          candidatEmail={candidatDetails.email}
          candidatTel={candidatDetails.telephone}
          candidatAccountManager={candidatDetails.accountManager}
          candidatConsultant={candidatDetails.consultant}
          candidatSeniorite={getSenioriteFromDate(candidatDetails.dateDebutExperience)}
          candidatCommentaire={candidatDetails.commentaire}
          candidatPointFort={candidatDetails.pointsforts}
          candidatSoftskills={candidatDetails.softskills}
          candidatFrancais={candidatDetails.francais}
          candidatAnglais={candidatDetails.anglais}
          candidatActuPackage={candidatDetails.actuellePackage}
          candidatActuFixe={candidatDetails.actuelleFixe}
          candidatActuVariable={candidatDetails.actuelleVariable}
          candidatActuInteress={candidatDetails.actuelleInteressement}
          candidatSouhaitePackage={candidatDetails.souhaitePackage}
          candidatsouhaiteFixe={candidatDetails.souhaiteFixe}
          candidatsouhaiteVariable={candidatDetails.souhaiteVariable}
          candidatsouhaiteInteress={candidatDetails.souhaiteInteress}
          candidatpreAvis={candidatDetails.preAvis}
          candidatdispoLe={candidatDetails.dispoLe}
          numCandidat={candidatDetails.numCandidat}
          processId={candidatDetails.processId}
          handleOpenModal={handleOpenModal}
          setMessageType={setMessageType}
        />
      ) : null,
    },
    { index: 3, component: <TabPanelTaches {...props} /> },
    { index: 4, component: <Selections {...props} /> },
    { index: 5, component: <Prospection {...props} /> },
    { index: 6, component: <Collegues {...props} /> },
  ];

  const filteredTabPanels = userRole === "ROLE_TESTEUR" ? allTabPanels.filter(p => p.index === 1) : allTabPanels;

  const missingPackageFields = isTalentManager && (
    !candidatDetails?.actuellePackage || candidatDetails.actuellePackage.trim() === "" ||
    !candidatDetails?.actuelleFixe || candidatDetails.actuelleFixe.trim() === "" ||
    !candidatDetails?.souhaitePackage || candidatDetails.souhaitePackage.trim() === "" ||
    !candidatDetails?.souhaiteFixe || candidatDetails.souhaiteFixe.trim() === "" ||
    !candidatDetails?.souhaiteVariable || candidatDetails.souhaiteVariable.trim() === ""
  );

  return (
    <Box sx={{ px: '16px', pb: 1, backgroundColor: '#f1f5f9', minHeight: '100vh' }}>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Navigation */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1.5, pb: 1, flexWrap: 'wrap' }}>
            {(selected && selectedCandidats != undefined && selectedCandidats.length > 0 && candidatIndex !== undefined) && (
              <>
                {idSelection ? (
                  <Box sx={{ fontStyle: "italic", fontSize: "smaller", display: "flex", alignItems: "center" }}>
                    <Link to={getUrlSelectedSelection()} style={{ textDecoration: "none", color: '#03407b' }}>
                      <ArrowBack fontSize="small" />
                    </Link>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 600, fontFamily: 'StyleFont', ml: 0.5 }}>
                      Sélection : {selectionData.isLoading ? "..." : selectionData.data.selectionName}
                    </Typography>
                  </Box>
                ) : (
                  <Box onClick={() => history.goBack()} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#03407b', '&:hover': { color: '#02357a' } }}>
                    <ArrowBack fontSize="small" />
                  </Box>
                )}
                <Button variant="outlined" size="small" disabled={candidatIndex === 0} onClick={previousCandidat}
                  sx={{ ...navBtnSx, borderColor: '#aed6f1', color: '#02357a', '&:hover': { borderColor: '#03407b', backgroundColor: '#ebf4fb' }, '&.Mui-disabled': { borderColor: '#e5e7eb', color: '#d1d5db' } }}>
                  Précédent
                </Button>
                {userRole !== "ROLE_TESTEUR" && (
                  <Button variant="contained" size="small" onClick={handleOpenDeleteDialog} disabled={loadingToDelete}
                    sx={{ ...navBtnSx, backgroundColor: '#ef4444', boxShadow: 'none', '&:hover': { backgroundColor: '#dc2626' } }}>
                    Supprimer
                  </Button>
                )}
                <Button variant="outlined" size="small" disabled={candidatIndex === selectedCandidats.length - 1} onClick={nextCandidat}
                  sx={{ ...navBtnSx, borderColor: '#aed6f1', color: '#02357a', '&:hover': { borderColor: '#03407b', backgroundColor: '#ebf4fb' }, '&.Mui-disabled': { borderColor: '#e5e7eb', color: '#d1d5db' } }}>
                  Suivant
                </Button>
                {filterData.isFiltering && (
                  <Button variant="contained" size="small" onClick={handleSaveFilterToSelection} disabled={filterData.loading}
                    sx={{ ...navBtnSx, background: 'linear-gradient(135deg, #0556a4, #03407b)', boxShadow: '0 2px 8px rgba(99,102,241,0.3)' }}>
                    Sauvegarder {filterData.loading && <CircularProgress size={13} sx={{ ml: 1, color: '#fff' }} />}
                  </Button>
                )}
              </>
            )}

            {(selected && idSelection) && (
              <Chip
                label={`${(history.location.state?.candidatIndex ?? 0) + 1} / ${history.location.state?.numbersTotalOfSelections ?? '?'}`}
                size="small"
                sx={{ ml: 'auto', backgroundColor: '#ebf4fb', color: '#02357a', fontWeight: 700, border: '1px solid #aed6f1' }}
              />
            )}
          </Box>

          {/* ── Hero ── */}
          <Box
            sx={{
              background: 'linear-gradient(135deg, #03407b 0%, #02357a 55%, #022d68 100%)',
              borderRadius: '14px',
              p: { xs: '14px 18px', md: '16px 24px' },
              mb: 1.5,
              mt: (selected && selectedCandidats?.length > 0 && candidatIndex !== undefined) ? 0 : 1.5,
              position: 'relative',
              overflow: 'hidden',
              boxShadow: '0 6px 24px rgba(99,102,241,0.30)',
            }}
          >
            <Box sx={{ position: 'absolute', top: -50, right: -50, width: 190, height: 190, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.07)', pointerEvents: 'none' }} />
            <Box sx={{ position: 'absolute', bottom: -20, right: '20%', width: 110, height: 110, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.04)', pointerEvents: 'none' }} />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', position: 'relative', zIndex: 1 }}>
              <Avatar sx={{ width: { xs: 48, md: 58 }, height: { xs: 48, md: 58 }, background: 'rgba(255,255,255,0.2)', border: '2px solid rgba(255,255,255,0.45)', fontSize: { xs: '1rem', md: '1.2rem' }, fontWeight: 700, color: '#fff', flexShrink: 0, letterSpacing: '0.04em' }}>
                {(prenom?.[0] || '').toUpperCase()}{(nom?.[0] || '').toUpperCase()}
              </Avatar>

              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap', mb: 0.2 }}>
                  <Typography sx={{ color: '#fff', fontSize: { xs: '1rem', sm: '1.25rem', md: '1.4rem' }, fontWeight: 700, fontFamily: 'StyleFont', lineHeight: 1.2 }}>
                    {candidatDetails.titre} {(candidatDetails.nom || '').toUpperCase()} {candidatDetails.prenom}
                  </Typography>
                  {candidatDetails.numCandidat && (
                    <Chip label={`N° ${candidatDetails.numCandidat}`} size="small"
                      sx={{ backgroundColor: 'rgba(255,255,255,0.18)', color: '#fff', fontWeight: 700, fontSize: '1rem', border: '1px solid rgba(255,255,255,0.3)', height: 20, '& .MuiChip-label': { px: 1 } }} />
                  )}
                </Box>
                {candidatDetails.updatedAt && (
                  <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.73rem', fontStyle: 'italic' }}>
                    Mise à jour : {moment(candidatDetails.updatedAt).locale("fr").format("DD MMMM YYYY - HH:mm")}
                  </Typography>
                )}
              </Box>

              {userRole !== "ROLE_TESTEUR" && (
                <Box className="hero-toolbar">
                  {/* Stop emailing switch */}
                  <Tooltip title="STOP EMAILING" placement="top" arrow>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Switch checked={!candidatDetails.isMailingAutorized} onChange={submitDisableMailing} disabled={loadingToDisableMailing} size="small"
                        sx={{ "& .MuiSwitch-thumb": { backgroundColor: !candidatDetails.isMailingAutorized ? "#fca5a5" : "#6ee7b7" }, "& .MuiSwitch-track": { backgroundColor: !candidatDetails.isMailingAutorized ? "#ef4444" : "#10b981", opacity: 0.75 } }} />
                    </Box>
                  </Tooltip>

                  {/* Separator */}
                  <Box className="hero-toolbar-divider" />

                  <Tooltip title="APPEL" placement="top"><span>
                    <Button startIcon={<BiPhone />} onClick={submitCallCandidat} disabled={loadingToCall} />
                  </span></Tooltip>
                  <SmsCandidat candidatTel={candidatDetails.telephone} candidatFullName={capitalize(prenom) + " " + nom.toUpperCase()} candidatFirstName={prenom} candidatLastName={nom.toUpperCase()} candidatId={idCandidat} loadData={loadData} setLoadData={setLoadData} />
                  <EmailModal loadData={loadData} setLoadData={setLoadData} prenom={prenom} emailTarget={email} serviceEmail={sendEmailCandidat} id={idCandidat} category={TABLE.CANDIDAT} openModal={openModal} setOpenModal={setOpenModal} handleOpenModal={handleOpenModal} messageType={messageType} />
                  <ShowAddCvCandidat {...{ files: cv, idCandidat, setReloadData, reloadData, fileName: candidatName }} />
                  <ShowCVCandidat {...{ files: cv, idCandidat, setReloadData, reloadData }} />
                  <Tooltip title={generatingCv ? "Formatage..." : "Format CV"} placement="top"><span>
                    <IconButton onClick={handleGenerateCvGoAndDev} disabled={generatingCv} size="small">
                      {generatingCv ? <CircularProgress size={14} sx={{ color: 'rgba(255,255,255,0.8)' }} /> : <AutoFixHigh fontSize="small" />}
                    </IconButton>
                  </span></Tooltip>
                </Box>
              )}
            </Box>
          </Box>

          {/* ── Side-by-side split ── */}
          <Box
            className={selected ? "contentWithHeadSelectionOpened" : "contentWithHeadSelectionClosed"}
            sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 8px rgba(0,0,0,0.07)' }}
          >
            <ReflexContainer orientation="vertical" style={{ height: '100%' }}>

              {/* LEFT — info panel */}
              <ReflexElement minSize={220} maxSize={420} style={{ overflow: 'hidden' }}>
                <Box sx={{ height: '100%', overflowY: 'auto', backgroundColor: '#f8fafc', p: 1.5, boxSizing: 'border-box' }}>

                  <SectionCard
                    title="Informations"
                    action={userRole !== "ROLE_TESTEUR" && (
                      <Tooltip title="Modifier" placement="top" arrow>
                        <IconButton
                          size="small"
                          onClick={() => editCandidat(idCandidat, history, candidatDetails.numCandidat)}
                          sx={{ p: 0.75, color: '#03407b', backgroundColor: '#ebf4fb', '&:hover': { backgroundColor: '#d6eaf8' } }}
                        >
                          <Edit sx={{ fontSize: 22 }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  >
                    <Informations {...candidatDetails} />
                  </SectionCard>

                  {userRole !== "ROLE_TESTEUR" && (
                    <SectionCard title="Disponibilité & Rémunération">
                      <PostRecherche {...candidatDetails} />
                    </SectionCard>
                  )}

                  {userRole !== "ROLE_TESTEUR" && (
                    <SectionCard title="Synthèse Consultant" noPadding>
                      <Box sx={{ p: 2 }}>
                        <SyntheseConsultant {...candidatDetails} />
                      </Box>
                    </SectionCard>
                  )}
                </Box>
              </ReflexElement>

              {/* Drag handle */}
              <ReflexSplitter style={{ width: '5px', backgroundColor: '#e2e8f0', cursor: 'col-resize', border: 'none', flexShrink: 0 }} />

              {/* RIGHT — tabs + content */}
              <ReflexElement style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Tab bar */}
                <Box sx={{ background: 'linear-gradient(135deg, #03407b 0%, #02357a 60%, #022d68 100%)', overflowX: 'auto', flexShrink: 0, boxShadow: '0 2px 8px rgba(99,102,241,0.2)' }}>
                  <Tabs value={value} onChange={handleTabs}
                    variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
                    sx={{
                      '& .MuiTabs-indicator': { backgroundColor: '#fff', height: 3, borderRadius: '3px 3px 0 0' },
                      '& .MuiTabs-scrollButtons': { color: '#fff', width: 32, '&.Mui-disabled': { opacity: 0.3 } },
                    }}>
                    {filteredTabs.map(tab => (
                      <Tab key={tab.name}
                        sx={{ minWidth: 50, color: 'rgba(255,255,255,0.7)', fontSize: '1rem', fontWeight: 600, letterSpacing: '0.05em', py: 1.4, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff' }, '&.Mui-selected': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.14)' } }}
                        label={<Box sx={{ display: 'flex', gap: '7px', alignItems: 'center', color: 'inherit' }}>{tab.icon}{!isSmMode && <span>{tab.name}</span>}</Box>}
                      />
                    ))}
                  </Tabs>
                </Box>

                {/* Tab content */}
                <Box sx={{ flex: 1, overflowY: 'auto', backgroundColor: '#fff' }}>
                  {missingPackageFields && (
                    <Alert severity="warning" variant="filled" sx={{ backgroundColor: "#ffae00", color: "white", fontWeight: "bold", fontSize: "1rem", borderRadius: 0 }}>
                      Attention : Un ou plusieurs champs NET MENSUEL sont vides. Veuillez les renseigner.
                    </Alert>
                  )}
                  {filteredTabPanels.map(tabPanel => (
                    <TabPanel key={tabPanel.index} value={value} index={tabPanel.index}>
                      {tabPanel.component}
                    </TabPanel>
                  ))}
                </Box>
              </ReflexElement>

            </ReflexContainer>
          </Box>

          <DialogDeleteCustom {...dialogDeleteProps} />
        </>
      )}
    </Box>
  );
}

export default withSnackbar(VisualiserCandidat);
